import preferences from './module';
import { Feature } from '@common-stack/client-react';

export default new Feature(preferences);
